import React from 'react';
import { Button, Form } from 'react-bootstrap';
import doller from '../../../assets/images/game/doller.svg';
import mines from '../../../assets/images/mines/mines.svg';
import whitegem from '../../../assets/images/mines/whitegem.svg';
import redgem from '../../../assets/images/header/gem.png';
import xicon from '../../../assets/images/mines/x.svg';

const ManualTab = () => {
  return (
    <div className='manual-tab'>
      <Form>
        <div className='mines-bet-box'>
          <Form.Group>
            <Form.Label>Bet Amount</Form.Label>
            <div className='bet-input pdd-200'>
              <img src={doller} alt='' />
              <Form.Control type='number' placeholder='58.52' />
              <div className='bet-input-btn'>
                <Button>1/2</Button>
                <Button>2x</Button>
                <Button>Max</Button>
              </div>
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Mines</Form.Label>
            <div className='bet-input'>
              <img src={mines} alt='' />
              <Form.Control type='number' placeholder='20' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Games</Form.Label>
            <div className='bet-input'>
              <img src={whitegem} alt='' />
              <Form.Control type='number' placeholder='3' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Payout</Form.Label>
            <div className='bet-input'>
              <img src={xicon} alt='' />
              <Form.Control type='number' placeholder='3' />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label>Profit</Form.Label>
            <div className='bet-input'>
              <img src={redgem} alt='' />
              <Form.Control type='number' placeholder='50.00' />
            </div>
          </Form.Group>
        </div>
        <div className='roll-dice'>
          <Button>CASHOUT </Button>
        </div>
      </Form>
      <div className='change-seed'>
        <Button>Change Seeds</Button>
      </div>
    </div>
  );
};

export default ManualTab;
